
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.177 4.74a.604.604 0 010-.855l1.708-1.708a.604.604 0 01.854 0l1.709 1.708a.604.604 0 00.854 0L9.01 2.177a.604.604 0 01.855 0l1.708 1.708a.604.604 0 00.854 0l1.709-1.708a.604.604 0 01.854 0l1.708 1.708a.604.604 0 00.854 0l1.709-1.708a.604.604 0 01.854 0l1.708 1.708a.604.604 0 010 .854l-1.708 1.709a.604.604 0 000 .854l1.708 1.708a.604.604 0 010 .855l-1.708 1.708a.604.604 0 000 .854l1.708 1.709a.604.604 0 010 .854l-1.708 1.708a.604.604 0 000 .854l1.708 1.709a.604.604 0 010 .854l-1.708 1.708a.604.604 0 01-.854 0l-1.709-1.708a.604.604 0 00-.854 0l-1.708 1.708a.604.604 0 01-.854 0l-1.709-1.708a.604.604 0 00-.854 0l-1.708 1.708a.604.604 0 01-.855 0l-1.708-1.708a.604.604 0 00-.854 0l-1.709 1.708a.604.604 0 01-.854 0l-1.708-1.708a.604.604 0 010-.854l1.708-1.709a.604.604 0 000-.854L2.177 14.99a.604.604 0 010-.854l1.708-1.709a.604.604 0 000-.854L2.177 9.865a.604.604 0 010-.855l1.708-1.708a.604.604 0 000-.854L2.177 4.739z","fill":"currentColor"}})])
          )
        }
      }
    